import { apiClient } from './api'

export interface ProjectDocumentItem {
  id: number
  project_id: number
  name: string
  type: string | null
  size: number
  uploaded_by: string | null
  uploaded_at: string | null
  category: string | null
  status: string | null
  url: string | null
  position: number
  created_at: string | null
  updated_at: string | null
}

export interface ProjectDocumentCreate {
  name: string
  type?: string | null
  size?: number
  uploaded_by?: string | null
  uploaded_at?: string | null
  category?: string | null
  status?: string | null
  url?: string | null
  position?: number
}

export const projectDocumentsService = {
  list(projectId: number): Promise<ProjectDocumentItem[]> {
    return apiClient.get(`/api/v1/projects/${projectId}/documents/`).then((r) => r.data)
  },
  create(projectId: number, body: ProjectDocumentCreate): Promise<ProjectDocumentItem> {
    return apiClient.post(`/api/v1/projects/${projectId}/documents/`, body).then((r) => r.data)
  },
  get(projectId: number, itemId: number): Promise<ProjectDocumentItem> {
    return apiClient.get(`/api/v1/projects/${projectId}/documents/${itemId}`).then((r) => r.data)
  },
  update(projectId: number, itemId: number, body: Partial<ProjectDocumentCreate>): Promise<ProjectDocumentItem> {
    return apiClient.patch(`/api/v1/projects/${projectId}/documents/${itemId}`, body).then((r) => r.data)
  },
  delete(projectId: number, itemId: number): Promise<void> {
    return apiClient.delete(`/api/v1/projects/${projectId}/documents/${itemId}`)
  },
}
